const ACHADMINISTRATOR = 'AchAdministrator';
const ADMINISTRATOR = 'Administrator';
const DEPTADMIN = 'DepartmentalAdministrator';
const USER = 'User';
const GENERALACCOUNTING = 'GeneralAccounting';

const isAnyAdmin = (userType) => {
  // let value = { ...userType };
  // console.log('isAnyAdmin is running, userType:', userType, 'value:', value);
  let value;
  if (Array.isArray(userType)) {
    if (userType.includes('AchAdministrator')) {
      value = 'AchAdministrator';
    }
  } else {
    value = userType;
  }
  return [ ACHADMINISTRATOR, ADMINISTRATOR, DEPTADMIN, GENERALACCOUNTING ].includes(value);
};

export default {
  ACHADMINISTRATOR,
  ADMINISTRATOR,
  DEPTADMIN,
  USER,
  GENERALACCOUNTING,
  isAnyAdmin,
  install(Vue, { store }) {
    Vue.prototype.$ACHADMINISTRATOR = ACHADMINISTRATOR;
    Vue.prototype.$ADMINISTRATOR = ADMINISTRATOR;
    Vue.prototype.$DEPTADMIN = DEPTADMIN;
    Vue.prototype.$USER = USER;
    Vue.prototype.$GENERALACCOUNTING = GENERALACCOUNTING;
    Vue.prototype.$isAnyAdmin = isAnyAdmin;

    store.$ACHADMINISTRATOR = ACHADMINISTRATOR;
    store.$ADMINISTRATOR = ADMINISTRATOR;
    store.$DEPTADMIN = DEPTADMIN;
    store.$USER = USER;
    store.$GENERALACCOUNTING = GENERALACCOUNTING;
    store.$isAnyAdmin = isAnyAdmin;
  },
};
